<template>
  <div v-if="displayList === true" style="padding: 0px !important;">
    <loading
      :active.sync="loadingPage"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <b-form
      v-if="planSeleccionado != null"
    >
      <div class="row pb-2 mb-5">
        <div class="col-sm-12 col-md-6 col-lg-3">
          <div class="image-container image-wrapper">
            <img
              class="plan-image"
              :src="carrito[planSeleccionado].imagenPlan"
              alt=""
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-8" style="font-size: 14px">
          <p class="titulo-plan">{{ carrito[planSeleccionado].nombrePlan }}</p>
          <p>
            <strong> Vigencia: </strong>
            {{ carrito[planSeleccionado].vigenciaInicio | formatoFecha }} al
            {{ carrito[planSeleccionado].vigenciaFin | formatoFecha }}
          </p>
          <p>
            <strong>Tipo plan:</strong>
            {{ carrito[planSeleccionado].tipoValidacion }}
          </p>
          <p>
            <strong>Personas incluidas:</strong>
            {{ carrito[planSeleccionado].numeroMaximo }}
          </p>
        </div>
      </div>

      <div
        v-for="(paciente, index) in carrito[planSeleccionado].pacientes"
        :key="index + 1"
      >
        <b-card>
          <div class="row">
            <div class="col-1">
              <p class="textoBold">{{ index + 1 }}</p>
            </div>
            <div class="col-9">
              <p class="textoBold" v-if="!paciente.fechaNacimiento">
                Paciente nuevo
              </p>
              <p v-else class="textoBold">
                {{
                  paciente.nombrePaciente +
                  " " +
                  paciente.apellidoP +
                  " " +
                  paciente.apellidoM
                }}
              </p>
            </div>
            <div class="col-1">
              <b-icon
                v-if="paciente.completo"
                style="font-size: 2em; color: #48cb33"
                icon="check"
              >
              </b-icon>
            </div>
            <div
              class="col-1"
              v-b-toggle="'card' + index"
              @click="rotar('card-', index)"
            >
              <b-icon
                @click="comprobarPropiedades()"
                icon="chevron-down"
                :rotate="rotarChevron['card-' + index] ? 180 : 0"
              >
              </b-icon>
            </div>
          </div>

          <b-collapse :id="'card' + index">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-4">
                <label class="textoSemibold"
                  >Nombre(s) <span style="color: red">*</span></label
                >
                <b-input-group>
                  <b-form-input
                    v-model="paciente.nombrePaciente"
                    minLength="3"
                    :placeholder="'Nombre(s)'"
                    @keypress="$global.soloLetras($event)"
                    @paste="$global.soloLetras($event)"
                    :state="
                      paciente.nombrePaciente != null &&
                      paciente.nombrePaciente.length >= 3
                    "
                    required
                  >
                  </b-form-input>
                  <b-form-invalid-feedback
                    :state="
                      paciente.nombrePaciente != null &&
                      paciente.nombrePaciente.length >= 3
                    "
                  >
                    El campo es requerido, mínimo 3 letras.
                  </b-form-invalid-feedback>
                </b-input-group>
              </div>

              <div class="col-sm-12 col-md-4 col-lg-4">
                <label class="textoSemibold"
                  >Apellido paterno <span style="color: red">*</span></label
                >
                <b-input-group>
                  <b-form-input
                    v-model="paciente.apellidoP"
                    minLength="3"
                    placeholder="Apellido Paterno *"
                    @keypress="$global.soloLetras($event)"
                    @paste="$global.soloLetras($event)"
                    :state="
                      paciente.apellidoP != null &&
                      paciente.apellidoP.length >= 3
                    "
                    required
                  ></b-form-input>
                  <b-form-invalid-feedback
                    :state="
                      paciente.apellidoP != null &&
                      paciente.apellidoP.length >= 3
                    "
                  >
                    El campo es requerido, mínimo 3 letras.
                  </b-form-invalid-feedback>
                </b-input-group>
              </div>

              <div class="col-sm-12 col-md-4 col-lg-4">
                <label class="textoSemibold"
                  >Apellido materno <span style="color: red">*</span></label
                >
                <b-input-group>
                  <b-form-input
                    v-model="paciente.apellidoM"
                    minLength="3"
                    placeholder="Apellido Materno *"
                    @keypress="$global.soloLetras($event)"
                    @paste="$global.soloLetras($event)"
                    :state="
                      paciente.apellidoM != null &&
                      paciente.apellidoM.length >= 3
                    "
                    required
                  ></b-form-input>
                  <b-form-invalid-feedback
                    :state="
                      paciente.apellidoM != null &&
                      paciente.apellidoM.length >= 3
                    "
                  >
                    El campo es requerido, mínimo 3 letras.
                  </b-form-invalid-feedback>
                </b-input-group>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-4 col-lg-4">
                <label class="textoSemibold"
                  >Sexo <span style="color: red">*</span></label
                >
                <b-input-group>
                  <b-form-select
                    v-model="paciente.sexo"
                    :options="listaSexo"
                    value-field="id"
                    text-field="nombre"
                    :state="paciente.sexo != null"
                    required
                  >
                  </b-form-select>
                  <b-form-invalid-feedback :state="paciente.sexo != null">
                    Debe seleccionar una opción
                  </b-form-invalid-feedback>
                </b-input-group>
              </div>

              <div class="col-sm-12 col-md-4 col-lg-4">
                <label class="textoSemibold"
                  >Fecha de nacimiento <span style="color: red">*</span></label
                >
                <b-input-group>
                  <b-form-datepicker
                    name="fecha"
                    show-decade-nav
                    :required="true"
                    :state="
                      paciente.fechaNacimiento ||
                      paciente.fechaNacimiento != null
                    "
                    v-model="paciente.fechaNacimiento"
                    @input="
                      verificarPersona(paciente, carrito[planSeleccionado])
                    "
                  ></b-form-datepicker>
                  <b-form-invalid-feedback
                    :state="paciente.fechaNacimiento ? true : false"
                  >
                    Debe seleccionar una fecha
                  </b-form-invalid-feedback>
                </b-input-group>
              </div>

              <div class="col-sm-12 col-md-4 col-lg-4">
                <label class="textoSemibold"
                  >Correo <span style="color: red">*</span></label
                >
                <div class="enLinea">
                  <b-input-group>
                    <b-form-input
                      type="email"
                      v-model="paciente.correo"
                      placeholder="Correo"
                      :state="validMail(paciente.correo)"
                      :disabled="paciente.habilitarCorreo"
                      required
                    ></b-form-input>
                  </b-input-group>
                  <b-form-checkbox
                    v-b-tooltip.hover
                    title="Mismo correo para los beneficiarios"
                    class="ml-2"
                    v-model="paciente.habilitarCorreo"
                    v-if="
                      index === 0 &&
                      carrito[planSeleccionado].pacientes.length > 1 &&
                      paciente.correo !== undefined &&
                      paciente.correo !== '' &&
                      paciente.correo !== null &&
                      carrito[planSeleccionado].numeroMaximo > 1
                    "
                    v-on:change="
                      seleccionarCorreoGlobal(planSeleccionado, $event)
                    "
                  >
                  </b-form-checkbox>
                </div>
                <b-form-invalid-feedback :state="validMail(paciente.correo)">
                  El campo es requerido
                </b-form-invalid-feedback>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-4 col-lg-4">
                <label class="textoSemibold"
                  >Teléfono <span style="color: red">*</span></label
                >
                <div class="enLinea row">
                  <vue-phone-number-input
                    v-model="paciente.telefono"
                    minLength="12"
                    maxLength="12"
                    :translations="traslationsTxt"
                    default-country-code="MX"
                    placeholder="Ingresa número a 10 dígitos: *"
                    :disabled="paciente.habilitarTelefono"
                    @update="onUpdateTel"
                    required
                  />

                  <b-form-checkbox
                    v-b-tooltip.hover
                    title="Mismo teléfono para los beneficiarios"
                    class="ml-2"
                    v-model="paciente.habilitarTelefono"
                    v-if="
                      index === 0 &&
                      carrito[planSeleccionado].pacientes.length > 1 &&
                      paciente.telefono !== undefined &&
                      paciente.telefono !== '' &&
                      paciente.telefono !== null &&
                      carrito[planSeleccionado].numeroMaximo > 1
                    "
                    v-on:change="
                      seleccionarTelefonoGlobal(planSeleccionado, $event)
                    "
                  >
                  </b-form-checkbox>
                </div>
                <b-form-invalid-feedback
                  :state="
                    paciente.telefono !== undefined &&
                    paciente.telefono !== '' &&
                    paciente.telefono !== null
                  "
                >
                  El campo es requerido
                </b-form-invalid-feedback>
              </div>

              <div class="col-sm-12 col-md-4 col-lg-4">
                <label class="textoSemibold"
                  >Tipo de beneficiario <span style="color: red">*</span></label
                >
                <br />
                <b-input-group>
                  <b-form-select
                    v-model="paciente.tipoAsegurado"
                    :options="listaAsegurado"
                    value-field="idTipoAsegurado"
                    text-field="descripcion"
                    :state="paciente.tipoAsegurado != null"
                    v-on:change="
                      verificarTitular(
                        planSeleccionado,
                        index,
                        paciente.tipoAsegurado
                      )
                    "
                    required
                  >
                  </b-form-select>
                  <b-form-invalid-feedback
                    :state="paciente.tipoAsegurado != null"
                  >
                    Debe seleccionar una opción
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback
                    v-if="paciente.tipoAsegurado === 1"
                    :state="paciente.tipoAsegurado != null"
                  >
                    Titular
                  </b-form-valid-feedback>
                </b-input-group>
              </div>

              <div class="col-sm-12 col-md-4 col-lg-4"></div>
            </div>

            <div class="row mt-4">
              <div
                class="col-12"
                v-if="carrito[planSeleccionado].requiereVendedor"
              >
                <p>
                  <strong
                    >{{ carrito[planSeleccionado].nombreTipoVendedor }}:</strong
                  >* En caso de NO contar con la información colocar “No
                  Aplica”.
                </p>
                <div class="enLinea">
                  <b-input-group>
                    <b-form-input
                      v-model="paciente.nombreVendedor"
                      :disabled="paciente.habilitarNombreVendedor"
                    ></b-form-input>
                  </b-input-group>
                  <b-form-checkbox
                    v-b-tooltip.hover
                    title="Mismo nombre del vendedor para los beneficiarios"
                    class="ml-2"
                    v-model="paciente.habilitarNombreVendedor"
                    v-if="
                      index === 0 &&
                      carrito[planSeleccionado].pacientes.length > 1 &&
                      paciente.nombreVendedor !== undefined &&
                      paciente.nombreVendedor !== '' &&
                      paciente.nombreVendedor !== null
                    "
                    v-on:change="seleccionarNombreVendedorGlobal(index, $event)"
                  >
                  </b-form-checkbox>
                </div>
                <b-form-invalid-feedback
                  :state="
                    paciente.nombreVendedor !== undefined &&
                    paciente.nombreVendedor !== '' &&
                    paciente.nombreVendedor !== null
                  "
                >
                  El campo es requerido
                </b-form-invalid-feedback>
              </div>
            </div>
          </b-collapse>
        </b-card>
      </div>
      <div
        class="row d-flex justify-content-center w-100"
        style="margin-top: 7%"
      >
        <div class="col-md-12 col-sm-12 col-lg-6 text-center">
          <b-button
            variant="outline-primary-custom"
            size="md"
            style="width: 60%"
            @click="mostrarModalContacto"
          >
            Agregar contacto principal
          </b-button>
        </div>
        <div class="col-md-12 col-sm-12 col-lg-6 text-center">
          <b-button
            size="md"
            class="altura-ajustable"
            style="width: 60%"
            :disabled="!contactoGuardadoExitoso"
            type="submit"
          >
            <span>Pasar al pago </span>
          </b-button>
        </div>
        <div class="d-flex justify-content-between mt-3 margin-ajustable">

          <b-form-checkbox
            size="md"
            id="separado"
            value="true"
            v-model="terminos"
            :state="terminos"
            required
          >
          </b-form-checkbox>

          <p style="font-size: 0.9rem">
            Acepto los
            <a class="underlineHover" v-on:click="abrirTerminos()">
              términos y condiciones
            </a>
            establecidos para la compra de planes con dentalia.
          </p>
        </div>
      </div>
    </b-form>

    <b-modal
      v-model="modalTerminos"
      title="Términos y condiciones"
      :hide-footer="true"
    >
      <div class="decargarTerminosCondiciones">
        <b-row class="mt-4 text-right">
          <b-col>
            <b-button
              @click="downloadBase64File"
              class="DosSecundario m-1"
              size="sm"
            >
              Descargar Terminos y Condiciones
            </b-button>
          </b-col>
        </b-row>
      </div>
      <iframe
        :src="terminoCondicionesBase64"
        frameborder="0"
        height="400%"
        width="100%"
        style="height: 90vh"
        onload="document.getElementById('loadImg').style.display='none';"
        class="iframeTerminos"
      >
      </iframe>
    </b-modal>
    <b-modal
      v-model="modalContacto"
      title="Configurar contacto principal"
      :hide-footer="true"
    >
      <b-form v-on:submit.prevent="guardarContactoPrincipal()">
        <b-row>
          <b-col cols="10"> ¿El contacto principal es paciente? </b-col>
          <b-col cols="1">
            <b-form-checkbox
              v-model="isContactoPrincipalPaciente"
              switch
              style="text-align: right; margin-left: 35%"
            >
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-input-group v-if="isContactoPrincipalPaciente">
          <b-form-select
            id="selectPacientes"
            class="mt-4 mb-5"
            v-model="contactoPrincipal"
            :options="
              listaPacientes.map((paciente) => ({
                text: paciente.nombreCompleto,
                value: paciente,
              }))
            "
            placeholder="Selecciona un paciente"
            required
            :state="
              contactoPrincipal.nombreCompleto != null &&
              contactoPrincipal != ''
            "
          >
          </b-form-select>
          <b-form-invalid-feedback
            :state="contactoPrincipal.nombreCompleto && contactoPrincipal != ''"
          >
            El campo es requerido
          </b-form-invalid-feedback>
        </b-input-group>

        <div v-else class="mt-4 mb-2">
          <b-input-group>
            <b-form-input
              class="form-control-sm"
              v-model="contactoPrincipal.nombreCompleto"
              minLength="3"
              :placeholder="'Nombre completo'"
              @keypress="$global.soloLetras($event)"
              @paste="$global.soloLetras($event)"
              :state="
                contactoPrincipal.nombreCompleto != null &&
                contactoPrincipal.nombreCompleto.length >= 3
              "
              required
            >
            </b-form-input>
            <b-form-invalid-feedback
              :state="
                contactoPrincipal.nombreCompleto != null &&
                contactoPrincipal.nombreCompleto.length >= 3
              "
            >
              El campo es requerido, mínimo 3 letras.
            </b-form-invalid-feedback>
          </b-input-group>
          <b-input-group class="mt-2">
            <b-form-input
              class="form-control-sm"
              type="email"
              v-model="contactoPrincipal.correo"
              placeholder="Correo"
              :state="validMail(contactoPrincipal.correo)"
              required
            >
            </b-form-input>
            <b-form-invalid-feedback
              :state="
                contactoPrincipal.correo != null &&
                contactoPrincipal.correo.length >= 3
              "
            >
              El campo es requerido
            </b-form-invalid-feedback>
          </b-input-group>
          <div class="d-flex justify-content-start">
            <b-input-group class="mt-2">
              <vue-phone-number-input
                v-model="contactoPrincipal.telefono"
                minLength="12"
                maxLength="12"
                :translations="traslationsTxt"
                default-country-code="MX"
                placeholder="Ingresa número a 10 dígitos: *"
                @update="onUpdateTel"
                required
              />
              <b-form-invalid-feedback
                :state="
                  contactoPrincipal.telefono != null &&
                  contactoPrincipal.telefono.length >= 3
                "
              >
                El campo es requerido
              </b-form-invalid-feedback>
            </b-input-group>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <b-button
            type="submit"
            variant="primary"
            class="mt-3 mr-5"
            style="width: 35%"
            :disabled="loader"
          >
            <span v-if="!loader">Guardar </span>
            <span v-else>
              <b-spinner small></b-spinner>
              Cargando...
            </span>
          </b-button>
          <b-button
            style="width: 35%"
            class="mt-3"
            variant="secondary"
            block
            :disabled="loader"
            @click="modalContacto = false"
          >
            <span v-if="!loader">Cancelar </span>
            <span v-else>
              <b-spinner small></b-spinner>
              Cargando...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "FormularioPaciente",
  components: {},
  props: {
    planSeleccionado: {
      default: 0,
      type: Number,
    },
    traerPacientes: Boolean,
  },
  data: () => ({
    terminos: false,
    fullPage: true,
    loadingPage: false,
    contactoGuardadoExitoso: false,
    modalContacto: false,
    isContactoPrincipalPaciente: true,
    contactoPrincipal: {
      nombreCompleto: null,
      correo: null,
      telefono: null,
    },
    listaParentesco: [],
    listaAsegurado: [],
    portalMsi: null,
    listaSexo: [],
    promociones: null,
    displayList: true,
    pagoRecurrente: null,
    pagoRecurrenteOps: [
      { text: "Si", value: true },
      { text: "No", value: false },
    ],
    traslationsTxt: {
      countrySelectorLabel: "Código de país",
      countrySelectorError: "Elige un país",
      phoneNumberLabel: "Número de teléfono",
      example: "Ejemplo :",
    },
    codigoTelefono: null,
    correoGlobal: false,
    telefonoGlobal: false,
    carrito: [],
    terminoCondicionesBase64: null,
    terminosCondicionesOps: [
      { text: "Si", value: true },
      { text: "No", value: false },
    ],
    aceptaTerminos: null,
    btnPagoRecurrente: false,
    loader: false,
    formularioCompleto: [],
    datosFormulario: {
      habilitarCorreo: null,
      habilitarNombreVendedor: null,
      habilitarPagoRecurrente: null,
      habilitarTelefono: null,
      nombrePaciente: null,
      apellidoP: null,
      apellidoM: null,
      sexo: null,
      fechaNacimiento: null,
      correo: null,
      telefono: null,
      tipoAsegurado: null,
      completo: null,
      nombreVendedor: null,
    },
    listaPacientes: [],
    isFormulariosCompletos: false,
    contactoGuardado: null,
    titularStripe: null,
    modalTerminos: false,
    rotarChevron: []
  }),
  watch: {
    cerrarModal() {
      this.$emit("cerrar-modal");
    },
    isContactoPrincipalPaciente() {
      this.contactoPrincipal = {
        nombreCompleto: null,
        correo: null,
        telefono: null,
      };
    },
  },
  created() {
    this.carrito = this.$session.get("carrito");

    this.traerSexo();
    this.traerMetodosPago();
    this.traerTipoAsegurado();
    this.traerDatosPortalLinea();
    //this.obtenerAvisoTerminosCondiciones();
    this.$session.set("step", 2);
    this.btnPagoRecurrente = this.$session.get("carrito")[0].pagoRecurrente;

    window.location.hash="no-back-button";
    window.location.hash="Again-No-back-button";
    window.onhashchange=function(){window.location.hash="no-back-button";}
  },
  mounted() {
    this.planSeleccionado = 0;
    this.carrito.forEach((plan) => {
      plan.pacientes.forEach((paciente) => {
        Object.assign(paciente, { habilitarTelefono: false });
        Object.assign(paciente, { habilitarCorreo: false });
        Object.assign(paciente, { habilitarPagoRecurrente: false });
        Object.assign(paciente, { habilitarNombreVendedor: false });
      });
    });
  },
  methods: {
    abrirTerminos() {
      this.modalTerminos = true;
    },
    generarBodyCheckoutSession() {
      let pacientesEnviar = [];
      this.carrito.forEach((element) => {
        console.log(element);
        let beneficiarios = [];
        if (element.numeroMaximo > 1) {
          const pxTitular = element.pacientes.filter(
            (elemento) => elemento.tipoAsegurado === 1
          );
          //const pxBeneficiarios = element.pacientes.filter((elemento) => elemento.tipoAsegurado === 2);
          element.pacientes.forEach((px) => {
            if (px.tipoAsegurado === 2) {
              let beneficiario = {
                idPaciente: px.idPaciente,
                nombreCompleto:
                  px.nombrePaciente + " " + px.apellidoM + " " + px.apellidoP,
                nombreVendor: px.habilitarNombreVendedor
                  ? px.nombreVendedor
                  : null,
                idTipoAsegurado: px.tipoAsegurado,
                idDefaultPrice: element.idDefaultPriceStripe,
                idDefaultPriceSubscription: element.idDefaultPriceStripeSubscription,
                idPlan: element.idPlan,
              };
              beneficiarios.push(beneficiario);
            }
          });

          let pacientePlan = {
            idPaciente: pxTitular[0].idPaciente,
            nombreCompleto:
              pxTitular[0].nombrePaciente +
              " " +
              pxTitular[0].apellidoM +
              " " +
              pxTitular[0].apellidoP,
            nombreVendor: pxTitular[0].nombreVendedor,
            idTipoAsegurado: pxTitular[0].tipoAsegurado,
            idDefaultPrice: element.idDefaultPriceStripe,
            idDefaultPriceSubscription: element.idDefaultPriceStripeSubscription,
            idPlan: element.idPlan,
            precioPlan: element.precio,
            precioCotizado: element.precioSinComision,
            precioCotizadoIva: element.precioCotizadoIva,
            montoComision: element.montoComision,
            comision : element.comision,
            montofijoTransaccion: element.montofijoTransaccion,
            beneficiarios: beneficiarios,
          };
          pacientesEnviar.push(pacientePlan);
        } else {
          const px = element.pacientes[0];
          let pacientePlan = {
            idPaciente: px.idPaciente,
            nombreCompleto:
              px.nombrePaciente + " " + px.apellidoM + " " + px.apellidoP,
            nombreVendor: px.habilitarNombreVendedor ? px.nombreVendedor : null,
            idTipoAsegurado: px.tipoAsegurado,
            idDefaultPrice: element.idDefaultPriceStripe,
            idDefaultPriceSubscription: element.idDefaultPriceStripeSubscription,
            idPlan: element.idPlan,
            precioPlan: element.precio,
            precioCotizado: element.precioSinComision,
            precioCotizadoIva: element.precioCotizadoIva,
            montoComision: element.montoComision,
            comision : element.comision,
            montofijoTransaccion: element.montofijoTransaccion,
            beneficiarios: [],
          };
          pacientesEnviar.push(pacientePlan);
        }
      });
      console.log("**********")
      console.log(pacientesEnviar)
      let objetoEnviar = {
        pacientesPlan: pacientesEnviar,
        titularStripe: this.titularStripe,
        idMsiPortal: 1,
        aceptoTerminos: this.terminos,
        idMetodoPagoStripe: this.metodoPagoSeleccionado
      };
      return objetoEnviar;
    },

    async crearCheckoutSession() {

      const url = this.$baseBack + "/api/integraciones/stripe/generar/pago";
      await this.$http
        .post(url, this.generarBodyCheckoutSession())
        .then((response) => {
          if (response.status == 200) {
            window.location.href = response.data.data.urlPago;
          }
        })
        .catch((err) => {
          console.error(err);
          this.mostrarMensajeError(err);
        });
    },

    async mostrarModalContacto() {
      await this.comprobarPropiedades();
      await this.generarListaPacientes();

      const indexPacienteSinTitular = this.carrito.findIndex((element) => {
        return (
          element.numeroMaximo > 1 &&
          !element.pacientes.some((paciente) => paciente.tipoAsegurado === 1)
        );
      });

      if (indexPacienteSinTitular !== -1) {
        this.$swal({
          icon: "error",
          title:
            "Por favor seleccione un paciente titular para el plan " +
            (indexPacienteSinTitular + 1) +
            " " +
            this.carrito[indexPacienteSinTitular].nombrePlan,
          confirmButtonText: "Aceptar",
          showCancelButton: false,
        });
        return;
      }

      if (!this.isFormulariosCompletos) {
        this.$swal({
          icon: "error",
          title:
            "Por favor llene completamente los formularios de los pacientes",
          confirmButtonText: "Aceptar",
          showCancelButton: false,
        });
      } else {
        this.modalContacto = true;
      }
    },

    async guardarContactoPrincipal() {
      this.loader = true;
      await this.$http
        .post(
          this.$api + "integraciones/stripe/guardar/titular",
          this.contactoPrincipal
        )
        .then((response) => {
          if (response.data.data) {
            this.contactoGuardado = response.data.data;
            this.titularStripe = response.data.data;
            this.contactoGuardadoExitoso = true;
            this.loader = false;
          }
        })
        .catch((err) => {
          this.errorTraerDatos(err);
          this.contactoGuardadoExitoso = false;
          this.loader = false;
        })
        .finally(() => {
          this.loader = false;
          this.modalContacto = false;
        });
    },
    async comprobarPropiedades() {
      this.carrito.forEach(plan => {
        plan.pacientes.forEach((paciente) => {
          // si el plan requiere vendedor se agrega la propiedad nombreVendedor al objeto de ejemplo, para posteriormente compararlo con el objeto del formulario
        if (plan.requiereVendedor) {
          this.datosFormulario.nombreVendedor = null;
        }else{
          delete this.datosFormulario.nombreVendedor;
          delete paciente.nombreVendedor;
        }

        //se obtiene un ejemplo del objeto completo
        const clavesFormularioCompleto = Object.keys(this.datosFormulario);

        //se comprueba si algún valor del array va vacío
        const todosLosValoresNoVacios = Object.values(
          paciente
        ).every((valor) => !!valor || valor === false);

        paciente.completo = null;

        const clavesFormularioPaciente = Object.keys(
          paciente
        );
 
        //se compara si el formulario actual tiene los mismos campos que clavesFormularioCompleto
        // y también verifica que todos los valores no estén vacíos
        if (
          clavesFormularioPaciente.length >= clavesFormularioCompleto.length &&
          todosLosValoresNoVacios
        ) {
          paciente.completo = true;
        } else {
          paciente.completo = false;
        }
      });
      });

      this.$forceUpdate();
    },

    generarListaPacientes() {
     let todosCompletos = true;
      this.carrito.forEach((plan) => {
           plan.pacientes.forEach((paciente) => {
             if (paciente.completo === false) {
               todosCompletos = false;
             }
           }
      )});
      if (todosCompletos) {
        this.isFormulariosCompletos = true;
        this.listaPacientes = this.carrito.reduce((result, plan) => {
          plan.pacientes.forEach((paciente) => {
            const nombreCompleto =
              paciente.nombrePaciente +
              " " +
              paciente.apellidoP +
              " " +
              paciente.apellidoM;
            const correo = paciente.correo;
            const telefono = paciente.telefono;

            result.push({
              nombreCompleto,
              correo,
              telefono,
            });
          });
          return result;
        }, []);
      }
      this.isFormulariosCompletos = todosCompletos;
      this.$forceUpdate();
    },

    validMail(email) {
      var expr =
        /^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      return expr.test(email);
    },
    verificarPersona(persona, { idPlan }) {
      this.loadingPage = true;

      this.$session.set("carrito", this.carrito);

      if (new Date(persona.fechaNacimiento) > new Date()) {
        this.$swal({
          icon: "warning",
          title: "La fecha de nacimiento no puede ser superior a hoy",
          confirmButtonText: "OK",
        });
        this.loadingPage = false;
        setTimeout(() => {
          persona.fechaNacimiento = null;
        }, 200);
        return false;
      } else if (
        !persona.nombrePaciente ||
        persona.nombrePaciente === "" ||
        !persona.apellidoP ||
        persona.apellidoP === "" ||
        !persona.apellidoM ||
        persona.apellidoM === ""
      ) {
        this.$swal({
          icon: "warning",
          title: "Debes llenar los campos del nombre",
          confirmButtonText: "OK",
        });
        this.loadingPage = false;
        return false;
      } else {
        this.displayList = false;
        const dtoPersona = {};
        dtoPersona.nombre = persona.nombrePaciente.trim().toUpperCase();
        dtoPersona.apaterno = persona.apellidoP.trim().toUpperCase();
        dtoPersona.amaterno = persona.apellidoM.trim().toUpperCase();
        dtoPersona.fechaNacimiento = this.$moment(
          persona.fechaNacimiento
        ).format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        dtoPersona.idPlan = idPlan;

        this.$http
          .post(this.$api + "plan/findPersonaCuentaConPlanBase", dtoPersona)
          .then((response) => {
            const carrito = this.$session.get("carrito");
            if (carrito[this.planSeleccionado].esUpgrade) {
              if (response.data.data.tienePlan === false) {
                this.$swal({
                  icon: "warning",
                  title:
                    "El paciente que estas ingresando no cuenta con ningun plan base, solo se estarán adquiriendo los modulos de éste plan",
                  confirmButtonText: "OK",
                });
              }
            }
            if (response.data.data.tienePlan === true) {
              this.$swal({
                icon: "warning",
                title:
                  "El paciente que estas ingresando, ya cuenta con el plan base seleccionado vigente",
                confirmButtonText: "OK",
              });
            }

            if (response.data.data.existe.length > 0) {
              response.data.data.existe.forEach((e) => {
                if (e.tipoContacto === 2) {
                  persona.telefono = e.conctacto;
                }
                if (e.tipoContacto === 3) {
                  persona.correo = e.conctacto;
                }
                persona.idPaciente = e.idPaciente;
              });
            } else {
              this.guardarPaciente(persona);
            }
          })
          .catch((e) => {
            console.info(e);
            this.displayList = true;
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingPage = false;
            }, 500);

            this.displayList = true;
          });
      }
    },

    async guardarPaciente(persona) {
      const data = {
        nombre: persona.nombrePaciente,
        apelleidoPaterno: persona.apellidoP,
        apellidoMaterno: persona.apellidoM,
        sexo: persona.sexo,
        fechaNacimiento: this.$moment(persona.fechaNacimiento).format(
          "YYYY-MM-DD[T]HH:mm:ss[Z]"
        ),
        correo: persona.correo,
        telefono: persona.telefono,
        tipoAsegurado: persona.tipoAsegurado,
        tipoBeneficiario: null,
      };
      await this.$http
        .post(this.$api + "plan/guardarPaciente", data)
          .then((response) => {
            persona.idPaciente = response.data.data;
          })
        .finally(() => {
          this.loader = false;
        });
    },
    traerSexo() {
      let url = this.$api + "catalogos/listaSexo";
      this.$http
        .post(url)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({
              id: null,
              nombre: "SEXO: *",
            });

            this.listaSexo = response.data.data;
          }
        })
        .catch((err) => {
          this.errorTraerDatos(err);
        });
    },
    traerTipoAsegurado() {
      const url = this.$api + "catalogos/planpaciente/tipoAsegurado";
      this.$http
        .get(url)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({
              idTipoAsegurado: null,
              descripcion: "TIPO DE BENEFICIARIO: *",
            });

            this.listaAsegurado = response.data.data;
          }
        })
        .catch((err) => {
          this.errorTraerDatos(err);
        });
    },
    seleccionarCorreoGlobal(indicePlan, $event) {
      if ($event) {
        /*this.correoGlobal = true;
          this.carrito.forEach((plan) => {
            plan.pacientes.forEach(paciente => {
               this.$set(paciente, 'correo',plan.pacientes[0].correo)
              paciente.correo = plan.pacientes[0].correo;
            })
          });*/
        this.carrito[indicePlan].pacientes.forEach((paciente, index) => {
          if (index !== 0) {
            this.$set(
              paciente,
              "correo",
              this.carrito[indicePlan].pacientes[0].correo
            );
            paciente.correo = this.carrito[indicePlan].pacientes[0].correo;
          }
          paciente.habilitarCorreo = true;
        });
      } else {
        /*this.correoGlobal = false;
          this.carrito.forEach((plan, i) => {
            plan.pacientes.forEach((paciente, index) => {
              if(index !== 0){
                 this.$set(paciente, 'correo',undefined)
                 this.carrito[i].pacientes[index].correo = undefined;
                 paciente.correo = undefined;
              }
            })
          });*/
        this.carrito[indicePlan].pacientes.forEach((paciente, index) => {
          if (index !== 0) {
            this.$set(paciente, "correo", undefined);
            paciente.correo = undefined;
          }
          paciente.habilitarCorreo = false;
        });
      }
    },
    seleccionarTelefonoGlobal(indicePlan, $event) {
      if ($event) {
        /*this.telefonoGlobal = true;
          this.carrito.forEach((plan) => {
            plan.pacientes.forEach(paciente => {
              this.$set(paciente, 'telefono',plan.pacientes[0].telefono)
              paciente.telefono = plan.pacientes[0].telefono;
            })
          });*/
        this.carrito[indicePlan].pacientes.forEach((paciente, index) => {
          if (index !== 0) {
            this.$set(
              paciente,
              "telefono",
              this.carrito[indicePlan].pacientes[0].telefono
            );
            paciente.telefono = this.carrito[indicePlan].pacientes[0].telefono;
          }
          paciente.habilitarTelefono = true;
        });
      } else {
        /*this.telefonoGlobal = false;
          this.carrito.forEach((plan) => {
            plan.pacientes.forEach((paciente, index) => {
              if(index !== 0){
                this.$set(paciente,'telefono',undefined)
                 paciente.telefono = undefined;
              }
            })
          });*/
        this.carrito[indicePlan].pacientes.forEach((paciente, index) => {
          if (index !== 0) {
            this.$set(paciente, "telefono", undefined);
            paciente.telefono = undefined;
          }
          paciente.habilitarTelefono = false;
        });
      }
    },
    seleccionarPagoRecurrenteGlobal(indicePlan, $event) {
      if ($event) {
        this.carrito[indicePlan].pacientes.forEach((paciente, index) => {
          if (index !== 0) {
            this.$set(
              paciente,
              "pagoRecurrente",
              this.carrito[indicePlan].pacientes[0].pagoRecurrente
            );
            paciente.pagoRecurrente =
              this.carrito[indicePlan].pacientes[0].pagoRecurrente;
          }
          paciente.habilitarPagoRecurrente = true;
        });
      } else {
        this.carrito[indicePlan].pacientes.forEach((paciente, index) => {
          if (index !== 0) {
            this.$set(paciente, "pagoRecurrente", undefined);
            paciente.pagoRecurrente = undefined;
          }
          paciente.habilitarPagoRecurrente = false;
        });
      }
    },
    seleccionarNombreVendedorGlobal(indicePlan, $event) {
      if ($event) {
        this.carrito[indicePlan].pacientes.forEach((paciente, index) => {
          if (index !== 0) {
            this.$set(
              paciente,
              "nombreVendedor",
              this.carrito[indicePlan].pacientes[0].nombreVendedor
            );
            paciente.nombreVendedor =
              this.carrito[indicePlan].pacientes[0].nombreVendedor;
          }
          paciente.habilitarNombreVendedor = true;
        });
      } else {
        this.carrito[indicePlan].pacientes.forEach((paciente, index) => {
          if (index !== 0) {
            this.$set(paciente, "nombreVendedor", undefined);
            paciente.nombreVendedor = undefined;
          }
          paciente.habilitarNombreVendedor = false;
        });
      }
    },
    onUpdateTel(payload) {
      if (payload.countryCallingCode != undefined) {
        this.codigoTelefono = payload.countryCallingCode;
      }
    },
    verificarTitular(indicePlan, indicePAciente, tipoAsegurado) {
      if (this.carrito[indicePlan].numeroMaximo == 1) {
        return;
      }

      let contador = 0;
      if (tipoAsegurado === 1) {
        contador = this.carrito[indicePlan].pacientes.filter(
          (p) => p.tipoAsegurado === 1
        ).length;
      }

      if (contador > 1) {
        this.$swal({
          icon: "question",
          title: "¿Quiere quitar el antiguo titular?",
          confirmButtonText: "Aceptar",
          showCancelButton: true,
          allowEscapeKey: false,
          allowOutsideClick: false,
        }).then((aceptar) => {
          if (aceptar.value) {
            this.carrito[indicePlan].pacientes.forEach((px, index) => {
              if (index !== indicePAciente) {
                this.carrito[indicePlan].pacientes[index].tipoAsegurado = 2;
              }
            });
          } else {
            this.carrito[indicePlan].pacientes[
              indicePAciente
            ].tipoAsegurado = 2;
          }
        });
      }
    },
    async guardarPacienteTemporal() {
      if (!this.terminos) {
        this.$swal({
          icon: "error",
          title:
            "Para continuar, por favor acepte los términos y condiciones establecidos para la compra de planes con dentalia",
          confirmButtonText: "Aceptar",
          showCancelButton: false,
        });
        return;
      }
      this.loader = true;
      for (let plan of this.carrito) {
        for (let paciente of plan.pacientes.filter((p) => !p.idPaciente)) {
          this.guardarPaciente(paciente);
        }
      }

      this.$session.set("carrito", this.carrito);
      this.$session.set("promocion", this.promociones);
      this.$session.set("idMsiSeleccionado", this.promociones);
      this.$session.set("pagoRecurrente", this.pagoRecurrente);
      this.$session.set("aceptaTerminos", this.aceptaTerminos);
      this.crearCheckoutSession();
    },
    traerDatosPortalLinea() {
      this.idEmpresa = this.$localStorageService.getIdEmpresa();
      const datos = {
        idEmpresa: this.idEmpresa
      }

      const url = this.$api + "empresas/traerPortal/linea";
      return this.$http
        .post(url, datos)
        .then((response) => {
          this.portalMsi = response.data.data.mesesSinInteres;
        })
        .catch((err) => {
          this.errorTraerDatos(err);
        })
        .finally(() => {});
    },
    obtenerAvisoTerminosCondiciones() {
      const datos = {
        idAvisoSistema: 16
      }
      const url = this.$baseBack + "/api/erp/obtenerAvisoSistema";
      this.$http
        .post(url, datos)
        .then((response) => {
          if (response.data.data !== null) {
            this.terminoCondicionesBase64 =
              "data:application/pdf;base64, " + response.data.data;
          }
        })
        .catch((err) => {
          console.info(err);
        });
    },
    downloadBase64File() {
      const linkSource = this.terminoCondicionesBase64;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = "Terminos y Condiciones";
      downloadLink.click();
      this.loaderDescargar = false;
      this.$swal.fire({
        icon: "info",
        title: "Aviso",
        text: "Se descargo el archivo correctamente",
      });
    },
    rotar(id, index) {
      let idChevron = id + index;
      this.$set(this.rotarChevron, idChevron, !this.rotarChevron[idChevron]);
    },
  },
  notifications: {
    errorTraerDatos: {
      type: "error",
      title: "Error de servicio",
      message: "Error al traer los datos",
    },
  },
};
</script>

<style scoped>
   @media (max-width: 767px) {
    .altura-ajustable{
      margin-top: 5%;
    }

    .margin-ajustable{
      margin-left: 6%;
    }
  }
.decargarTerminosCondiciones {
  display: none !important;
}
@media only screen and (max-width: 600px) {
  .decargarTerminosCondiciones {
    display: block !important;
  }
  .iframeTerminos {
    display: none !important;
  }
}

.boton-agenda-inv {
  border-radius: 50rem;
  color: var(--color-icono);
  background-color: white;
  border-color: #fff;
  border: 1px solid #D6E7F3;
  padding: 1%;
}

.boton-agenda-inv:active {
  border-color: var(--color-icono);
}


.icon-small {
  font-size: 10%; /* Ajusta el tamaño del icono según tus necesidades */
}
.modal-title {
  color: #044169 !important;
  font-weight: bolder !important;;
}
</style>
